import { AdSizes, Bidder, BidderHelper } from "@repo/lib-domain-tag";
import { deviceUtil } from "@repo/lib-common";


const DeviceTypeInfo = deviceUtil.DeviceTypeInfo;
const worldPageBidderHelper = new BidderHelper();

//#region criteo
/*
const criteo_300x250 = Bidder.builder("criteo")
    .setIsEnabled(true).setParams({ networkId: 9934, zoneId: 1471385 })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
worldPageBidderHelper.addBidder(criteo_300x250);


const criteo_300x600_desktop = Bidder.builder("criteo")
    .setIsEnabled(true).setParams({ networkId: 9934, zoneId: 1471386 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
worldPageBidderHelper.addBidder(criteo_300x600_desktop);


const criteo_336x280_desktop = Bidder.builder("criteo")
    .setIsEnabled(true).setParams({ networkId: 9934, zoneId: 1471388 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes([[336, 280]]);
worldPageBidderHelper.addBidder(criteo_336x280_desktop);


const criteo_970x250_desktop = Bidder.builder("criteo")
    .setIsEnabled(true).setParams({ networkId: 9934, zoneId: 1471387 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
worldPageBidderHelper.addBidder(criteo_970x250_desktop);
*/
//#endregion

//#region adform
const adForm_300x250_desktop = Bidder.builder("adform")
    .setIsEnabled(true).setParams({ mid: 1231075 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);

worldPageBidderHelper.addBidder(adForm_300x250_desktop);


const adForm_300x600_desktop = Bidder.builder("adform")
    .setIsEnabled(true).setParams({ mid: 1231145 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
worldPageBidderHelper.addBidder(adForm_300x600_desktop);


const adForm_970x250_desktop = Bidder.builder("adform")
    .setIsEnabled(true).setParams({ mid: 1231146 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
worldPageBidderHelper.addBidder(adForm_970x250_desktop);


const adForm_300x250_mobile = Bidder.builder("adform")
    .setIsEnabled(true).setParams({ mid: 1231147 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.mobileDevices)
    .setAllowedSizes(AdSizes.prebid_300x250);
worldPageBidderHelper.addBidder(adForm_300x250_mobile);
//#endregion

//#region yandex
const yandex_300x250_mobile = Bidder.builder("yandex").setIsEnabled(true)
    .setParams({ placementId: 'R-A-2217816-1' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.mobileDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
worldPageBidderHelper.addBidder(yandex_300x250_mobile);

const yandex_300x250_desktop = Bidder.builder("yandex").setIsEnabled(true)
    .setParams({ placementId: 'R-A-2217816-1' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
worldPageBidderHelper.addBidder(yandex_300x250_desktop);

const yandex_300x600_desktop = Bidder.builder("yandex").setIsEnabled(true)
    .setParams({ placementId: 'R-A-2217816-2' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
worldPageBidderHelper.addBidder(yandex_300x600_desktop);


const yandex_970x250_desktop = Bidder.builder("yandex").setIsEnabled(true)
    .setParams({ placementId: 'R-A-2217816-3' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
worldPageBidderHelper.addBidder(yandex_970x250_desktop);

//#endregion

//#region admatic
const admatic_300x250 = Bidder.builder("admatic")
    .setIsEnabled(true).setParams({ networkId: 108266335578, host: 'gkbjdy0uaftq.rtb.admatic.com.tr' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
worldPageBidderHelper.addBidder(admatic_300x250);


const admatic_300x600_desktop = Bidder.builder("admatic")
    .setIsEnabled(true).setParams({ networkId: 108266335578, host: 'gkbjdy0uaftq.rtb.admatic.com.tr' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
worldPageBidderHelper.addBidder(admatic_300x600_desktop);

const admatic_336x280_desktop = Bidder.builder("admatic")
    .setIsEnabled(true).setParams({ networkId: 108266335578, host: 'gkbjdy0uaftq.rtb.admatic.com.tr' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes([[336, 280]]);
worldPageBidderHelper.addBidder(admatic_336x280_desktop);

const admatic_970x250_desktop = Bidder.builder("admatic")
    .setIsEnabled(true).setParams({ networkId: 108266335578, host: 'gkbjdy0uaftq.rtb.admatic.com.tr' })
    .setIsAnyDeviceAllowed(true).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
worldPageBidderHelper.addBidder(admatic_970x250_desktop);
//#endregion

//#region taboola
const taboola_300x250 = Bidder.builder("taboola")
    .setIsEnabled(true).setParams({ publisherId: 1554971, tagId: 'szctvPrebidData_300_250' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
worldPageBidderHelper.addBidder(taboola_300x250);

const taboola_300x600 = Bidder.builder("taboola")
    .setIsEnabled(true).setParams({ publisherId: 1554971, tagId: 'szctvPrebidData_300_600' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
worldPageBidderHelper.addBidder(taboola_300x600);

const taboola_970x250 = Bidder.builder("taboola")
    .setIsEnabled(true).setParams({ publisherId: 1554971, tagId: 'szctvPrebidData_970_250' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
worldPageBidderHelper.addBidder(taboola_970x250);

//#endregion

export { worldPageBidderHelper };
